// extracted by mini-css-extract-plugin
export default {"root":"StepperBottomMenu_root__MaqQZ"};